import React from "react";

export function Toast(message) {
    const el = document.createElement("div");
    el.className = "sd-toast";
    el.textContent = message;
    document.body.appendChild(el);
    setTimeout(() => {
        el.style.opacity = "0";
        setTimeout(() => el.remove(), 400);
    }, 2000);
};